module.exports = __webpack_public_path__ + "img/04_DSC7700-min.4134a775.jpg";